module.exports = "<ng-container *ngIf=\"src\">\n    <img *ngIf=\"!background\" [src]=\"src\"/>\n    <div *ngIf=\"background\" [style.background-image]=\"'url(' + src + ')'\"></div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-picture/user-picture.component.html
// module id = 575
// module chunks = 0